import React, { ButtonHTMLAttributes } from "react";
import { Link, LinkProps } from "react-router-dom";

type size = "small" | "medium" | "large" | "full";

export type ButtonProps = {
	loading?: boolean;
	className?: string;
	disabled?: boolean;
	warning?: boolean;
	size?: size;
	href?: LinkProps["to"] | "#";
	type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
	autofocus?: ButtonHTMLAttributes<HTMLButtonElement>["autoFocus"];
	children?: React.ReactNode;
	onClick?: () => Promise<void> | void;
};

const Button = ({
	loading,
	size,
	className,
	disabled,
	href,
	type,
	warning,
	autofocus = false,
	children,
	onClick = () => {},
}: ButtonProps): JSX.Element => {
	let SIZE = "";
	switch (size) {
		case "small":
			SIZE = "py-1 px-2 text-sm";
			break;
		case "medium":
			SIZE = "py-2 px-3";
			break;
		case "large":
			SIZE = "py-4 px-6 text-lg";
			break;
		case "full":
			SIZE = "py-2 px-3 w-full";
			break;
		default:
			SIZE = "py-2 px-3";
	}

	const CLASS_NAME = `text-sky-500 focus:outline-sky-400 rounded-md ${SIZE} ${
		className || ""
	} `;
	const _renderLoading = () => {
		return (
			<svg
				className="animate-spin -ml-1 mr-3 h-5 w-5"
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 24 24"
			>
				<circle
					className="opacity-25"
					cx="12"
					cy="12"
					r="10"
					stroke="currentColor"
					strokeWidth="3"
				></circle>
				<path
					className="opacity-75"
					fill="currentColor"
					d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
				></path>
			</svg>
		);
	};

	if (!!href) {
		return (
			<Link to={href} className={`${CLASS_NAME}`}>
				{children}
			</Link>
		);
	}
	return (
		<button
			disabled={disabled || loading}
			className={`flex justify-center ${CLASS_NAME}`}
			type={type}
			onClick={onClick}
			autoFocus={!!autofocus}
		>
			{loading ? _renderLoading() : children || "Click me"}
		</button>
	);
};

export default Button;
